import { invokeApi } from "../bl_libs/invokeApi";
import { getAccessToken } from "../utils/authStorage";

export const add_organization_api = async (data) => {
  const requestObj = {
    path: `api/organization/create`,
    method: "POST",
    headers: {
      Authorization: `Bearer ${getAccessToken()}`,
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const update_organization_api = async (data) => {
  const requestObj = {
    path: `api/organization/update`,
    method: "PUT",
    headers: {
      Authorization: `Bearer ${getAccessToken()}`,
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const get_organizations_list_api = async (data) => {
  const requestObj = {
    path: `api/organization/list`,
    method: "POST",
    headers: {
      Authorization: `Bearer ${getAccessToken()}`,
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const get_organization_detail_api = async (organization_id) => {
  const requestObj = {
    path: `api/organization/detail/${organization_id}`,
    method: "GET",
    headers: {
      Authorization: `Bearer ${getAccessToken()}`,
    },
  };
  return invokeApi(requestObj);
};

export const get_organization_delete_api = async (organization_id) => {
  const requestObj = {
    path: `api/organization/delete/${organization_id}`,
    method: "DELETE",
    headers: {
      Authorization: `Bearer ${getAccessToken()}`,
    },
  };
  return invokeApi(requestObj);
};

export const get_organizations_api = async () => {
  const requestObj = {
    path: `api/organization/list`,
    method: "GET",
    headers: {
      Authorization: `Bearer ${getAccessToken()}`,
    },
  };
  return invokeApi(requestObj);
};
